import { useTranslation } from '@/translations/i18n'

export const ImagesCounter = ({ count }: { count: number }) => {
	const { t } = useTranslation()

	return (
		<h4 className='text-neutral-700 text-sm'>
			{t('common:x_images_selected', { count })}
		</h4>
	)
}
